import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyC0DJIfJBQnB2PE4Nl0yvqHJFDZ19RL6og',
  authDomain: 'gyrofighters.firebaseapp.com',
  projectId: 'gyrofighters',
  storageBucket: 'gyrofighters.appspot.com',
  messagingSenderId: '617056770421',
  appId: '1:617056770421:web:4ac1ca8e0a092c016e5b3c',
  measurementId: 'G-SP610PK2K2',
  databaseURL:
    'https://gyrofighters-default-rtdb.europe-west1.firebasedatabase.app',
};

const firebaseApp = initializeApp(firebaseConfig);
export const database = getDatabase(firebaseApp);
export const auth = getAuth();

auth.languageCode = 'nb';
